import * as API from '../api';

// deprecated -- DO NOT USE
export const get = ({qtt}) => {
    console.log(qtt);
    if (qtt) {
        if (typeof qtt !== 'number') {
            return Promise.reject(new Error('Curiosities qtt should be a number'));
        }
        qtt = Math.floor(qtt);
        if (qtt <= 0) {
            return Promise.reject(new Error('Curiosities qtt should be at least one'));
        }
        return API.getCuriosity(qtt);
    }

    return API.getCuriosity();
};

// deprecated --DO NOT USE
export const getRandom = () => {
    return API.getRandomCuriosity();
};

export const setCuriosityShowed = (id) => {
    return API.setCuriosityShowed(id);
};



// WEBPACK FOOTER //
// ./src/controllers/curiosity.js